export const ARABIC_LABELS = {
    businessform: "بيانات تسجيل المنشأة",
    personalinfo: "بيانات المنشأة",
    bpname: "اسم المنشأة",
    sector: "نوع القطاع",
    select:"اختر",
    estdate: "تاريخ التأسيس",
    bptype:"الشكل القانوني",
    registerbtn:"تسجيل المنشأة",
    address:"عنوان",
    regions: "المنطقة",
    city:"المدينة",
    area:"الحي",
    phone:"الهاتف",
    fax:"الفاكس",
    email:"البريد الالكتروني",
    mangerinfo:"المدير العام",
    firstname:"الاسم الأول",
    lastname:"اسم العائلة",
    managername: "اسم المدير العام",
    mobile:"الهاتف المحمول",
    contactinfo:"ضابط الاتصال",
    comminfo:"ادخال بيانات السجل التجاري او الترخيص اجباري",
    commno: "رقم السجل التجاري",
    issuedate: "تاريخ الاصدار",
    expirydate: "تاريخ الانتهاء",
    commauthority:"جهة الاصدار",
    licenseno:"رقم الترخيص",
    gosinumber:"بيانات البنك و رقم الاشتراك في نظام التأمينات الاجتماعية",
    bankname: "اسم البنك",
    iban: "رقم الحساب / كاملآً",
    gosiinfo: "رقم الاشتراك في نظام التأمينات الاجتماعية",
    empinfo: "حصائيات أعداد الموظفين",
    malesaudi:"	الموظفون السعوديون الرجال",
    femalesaudi: "الموظفون السعوديون النساء",
    malenonsaudi:"الموظفون الغير سعوديون الرجال",
    femalenonsuadi: "الموظفون الغير سعوديون النساء",
    logininfo:"تفاصيل تسجيل الدخول",
    addinfo:"إضافة البيانات الشخصية",
    logintitle: "تسجيل الدخول",
    changeprofile: "تعديل بياناتي",
    loginname:"اسم تسجيل الدخول",
    password: "كلمة المرور",
    confirmpassword: "تأكيد كلمة المرور",
    addinfo:"إضافة البيانات المنشأة",
    toalinvoices: "مجموع الفواتير",
    paymentrecived: "عدد الفواتير المعتمدة",
    paymentrejected: "عدد الفواتير المرفوضة",
    noofcontracts: "عدد طلبات الدعم",
    noofpc:"عدد طالب عمل",
    totalinvamount: "إجمالي مبلغ الفواتير",
    invoicepermonth: "الفواتير سنويا",
    info: "معلومات",
    number:"رقم",
    dashboard:"لوحة القيادة",
    changepassword:"تغيير كلمة المرور",
    changebpprofile: "تغيير بيانات المنشأة",
    passinfo: "معلومات كلمة المرور",
    oldpassword: "كلمة المرور القديمة",
    newpassword: "كلمة المرور الجديدة",
    confirmpassword: "تأكيد كلمة المرور",
    updatepassword: "تحديث كلمة المرور",
    contract: "الاتفاقيات / العروض",
    createcontract:"تقديم طلب دعم ",
    contractlisth:"قائمة الاتفاقيات",
    commoninfo:"البيانات العامة",
    commcontract:"رقم الاتفاقية الشاملة",
    programname:"إسم برنامج الدعم",
    jobjustification: "مبرر طلب الوظائف",
    jopt1:"وظائف جديدة",
    jopt2:"احلال سعوديين",
    jopt3:"عقود تشغيل مع جهات خارجية",
    tojobdata:"إضافة بيانات الوظائف المدعومة",
    addjobscommon: "البيانات العامة",
    concity: "المدينة (مقرالوظيفة)",
    jobposition: "مسمى الوظيفة",
    searchselect: "ابحث واختر ...",
    noofpositions:"عدد الشواغر",
    gender:"الجنس",
    degreerequired: "المؤهل المطلوب",
    generalspecial:"التخصص العام",
    scispecial:"التخصص العلمي",
    trainingtype: "نوع التدريب",
    trcostpermonth: "تكلفة التدريب بالشهر",
    trinstitute: "جهة التدريب",
    trperiod: "مدة التدريب",
    empperiod: "فترة دعم التوظيف",
    trsalary: "الراتب الأساسي",
    housesalary:"بدل السكن",
    transportsalary:"بدل النقل",
    totaltrsalary:"اجمالي الراتب المدعوم من الصندوق",
    male:"ذكر",
    female: "أنثى",
    extraining: "خارج المنشأة",
    trsalarytile: "الراتب و البدلات خلال التدريب - دعم الصندوق يشمل الراتب الاساسي وبدل السكن والنقل فقط",
    empsalarytitle: "الراتب و البدلات بعد التدريب - دعم الصندوق يشمل الراتب الاساسي وبدل السكن والنقل فقط",
    traininginfo: "بيانات التدريب",
    contactpersonname: "اسم ضابط الاتصال",
    insdetail: "بيانات منشأة التدريب",
    coursedetail: "بيانات برنامج التدريب",
    proname: "برنامج التدريب",
    protype:"مستوى البرنامج",
    trstatus:" حالة الاعتراف",
    lblyes:"نعم",
    proexist:"وجود مادة التدريب",
    approve:"موافقة",
    jobdescription:"وصف الوظيفة",
    paymentinfo:"مؤشرات المالية الرئيسية",
    train:"التدريب",
    givtrperiod:"أقصى مدة للدعم",
    paymethod:"طريقة احتساب التكلفة",
    trcostpaying:"قيمة الرسوم / النسبة",
    percentage:"نسبة مئوية",
    maxtrcostshow:"أعلى تكلفة للتدريب",
    showemp: "الفترة اللاحقة للتدريب",
    percentgivesalary:"نسبة دعم الراتب الشهري",
    maxtakewaysalary:"الحد الأقصى للدعم",
    btnaddjob: "اضف وظيفة",
    btncancel:"الإلغاء",
    btnback:"العودة",
    btnexit:"الخروج",
    jobaddedinfo: "بيانات الوظائف المدعومة",
    listofagreement: "قائمة نواتج الاتفاقية",
    contractnumber: "رقم طلب الدعم",
    totalbudget: "القيمة الكلية",
    status:"الحالة",
    contracttype:"نوع الخدمة",
    eat:"التوظيف و التدريب",
    contrsalary:"راتب التدريب",
    conempsalary:"راتب التوظيف",
    conenddate:"يتم التوظيف خلال 45 يوم اعتبار من",
    action:"الإجراءات",
    coninfobasic: "بيانات الاتفاقية",
    startdate: "تاريخ الابتداء",
    enddate:"تاريخ الانتهاء",
    edit:"تحديث",
    view:"عرض",
    btneditjob: "تعديل الوظيفة",
    sendhrdf:"أرسل للصندوق",
    suretosend:"هل تريد المتابعة؟",
    linkpc: "الربط المباشر لطالب العمل",
    contitle: "قائمة طلب الدعم",
    seleposincontract: "اختر الوظيفة من طلب الدعم",
    nationalid: "رقم الهوية الوطنية طالب العمل",
    ninname: "اسم طالب العمل",
    degreename: "المؤهل العلمي",
    salaryduringtr:"الراتب و البدلات خلال التدريب",
    salduringemp: "الراتب و البدلات بعد التدريب",
    saldetails:"تفاصيل الراتب",
    workdetails:"تفاصيل العمل",
    workstartdate:"تاريخ الابتداء الفعلي",
    workhours:"	مجموع ساعات العمل لكل يوم",
    weekwork:"	عدد ايام العمل لكل اسبوع",
    other:"آخر",
    linkdetails: "تفاصيل الرابط",
    removepc: "فك ارتباط الموظفين",
    searchpc1:"بحث لطالب العمل",
    searchresult:"نتيجة البحث",
    pcid:"رقم الموظف",
    createattendance: "جداول الوقت و الحضور",
    attendanceinfo:"بيانات الحضور",
    selectmonth:"اختر الشهر",
    selectyear:"اختر السنة",
    attendancedetail:"بيانات الحضور و الوقت",
    smallnin: "رقم الهوية الوطنية",
    posstartdate:"تاريخ المباشرة",
    terminationdate:"تاريخ نهاية الخدمة",
    absentdays:" عدد أيام الغياب",
    presentdays:"عدد الأيام",
    aspercontract:"حسب طلب الدعم",
    asperpayment:"مبالغ الدعم",
    deduction:"الحسميات",
    addition:"الإضافات",
    hrdfsalary:"مبلغ دعم الصندوق",
    bpsalary:" المبلغ المستحق على المنشأة",
    totalninsalary: "إجمالي الراتب المحول\nإلى حساب الموظف",
    noneligiblereason:"سبب عدم أهلية\n الموظف للدعم",
    smcost:"التكلفة",
    smtr:"التدريب",
    smemp:"التوظيف",
    reason:"سبب عدم أهلية الموظف",
    btnprintattendance:"طباعة كشف قيد حساب رواتب الموظفين",
    attendancemonthyear: "شهر الاستحقاق",
    prononprofit:"برنامج دعم معاهد الشراكات الاستراتيجية",
    pcname:" اسم الموظف",
    sign:"التوقيع",
    bpsign:"ختم المنشأة",
    agreeprint:"أقرّ و أتعهّد باكتمال وصحّة ودقّة جميع البيانات الواردة أعلاه بما يتوافق مع بنود الاتفاقية الموقّعة مع الصندوق وأتحمّل كامل المسؤولية في حال ثبت خلاف ذلك",
    attendanceprint:"طباعة الحضور",
    addorupdateattendance:"إضافة أو تعديل الحضور",
    stotal:"الإجمالي",
    sar:"ريال",
    validattendance:"هذا اللون يدل على عدم اضافة بيانات الحضور لطالب العمل",
    invalidattendance:"هذا اللون يدل على أن الموظف لا تنطبق عليه شروط و ضوابط البرنامج",
    invsection:"قسم الفواتير",
    addinvoice:"إعداد فاتورة جديدة",
    invoicelist:"قائمة الفواتير",
    invperiod:"شهر المطالبة",
    invnumber:"رقم الفاتورة",
    searchinvoice:"البحث عن الفاتورة",
    invdetails:"بيانات الفاتورة",
    attahcments: "المرفقات",
    uploadingfiles:"جاري تحميل الملف...",
    uploadsuccess:"تم تحميل الملف بنجاح",
    delete:"حذف",
    bankattachment:"الايداع البنكي / كشف قيد الحساب",
    trainingattchment: "سند قبض (في حال وجود تدريب خارج المنشأة)",
    btnaddinvoice:"إضافة فاتورة",
    invdate:"تاريخ تقديم الفاتورة",
    invtotal:"القيمة الكلية للفاتورة",
    invstatus:"حالة الفاتورة",
    smallreason:"السبب",
    invoicedetail:"قائمة بيانات الفاتورة",
    downloadfile:"تنزيل الملف",
    unsupportedfile: "نوع الملف غير مدعوم",
    btnupdateinvoice: "تحديث الفاتورة",
    employeoffer:"قائمة بجميع الموظفين ونهاية الخدمة",
    searchbynin:"البحث الاسم الأول او برقم الهوية الوطنية",
    smallsearch:"البحث",
    conperiod:"مدة اتفاقية العمل",
    ninstatus:"حالة الربط",
    smallmonth:"الأشهر",
    viewinvoice:"عرض الفاتورة",
    printcontract:"حالة اتفاقيات الدعم",
    management:"ادارة",
    searchcontract:"البحث عن اتفاقيات الدعم",
    bpid:"كود المنشأة",
    printcontract:"ملف طلب الدعم",
    smalldate:"التاريخ",
    bpdetails:"بيانات المنشأة",
    paymentdetails:"بيانات إجمالي الدعم",
    totaljobs:"العدد المطلوب دعمهم",
    smallgosi:"رقم سجل التأمينات",
    totalmonthlycost:"اجمالي دعم تكاليف التدريب الخارجي",
    totaltrainpercent:"اجمالي دعم رواتب التدريب",
    totalemppercent:" اجمالي دعم رواتب التوظيف",
    smalltotal:"الإجمالي",
    positiondetail:"اجمالي الوظائف المستهدفة",
    smallnumber:"العدد",
    nojobposition:" عدد الوظائف",
    permonthcost:"تكلفة التدريب الشهرية",
    permonthtr:"دعم رواتب التدريب الشهرية",
    permonthemp:"دعم راتب التوظيف الشهرية",
    traininginsdesc:"وصف برامج التدريب الخارجي",
    programpurpose:"عنوان البرنامج",
    procost:"تكاليف التدريب",
    instname:"اسم المعهد",
    smalldesc:"الوصف",
    approveinvoice:"الموافقة على الفاتورة",
    approvebp:"تسجيل المنشأة",
    approvepc:"تسجيل طالب العمل",
    processlist:"قائمة العمليات قيد التنفيذ",
    processname:"اسم المعالجة",
    activityname:"وصف العملية",
    processdate:"تاريخ بداية الاجراء",
    activitydate:"تاريخ بداية العملية",
    activitystatus:"الحالة",
    useroperations:"نموذج ملخص العمليات",
    opdetail:"بيانات العملية",
    commprint:"ملف الدعم",
    myoperations:"عملياتي",
    btnreject:"مرفوض",
    btnforward:"اعادة ارسال",
    rejectionreason:"سبب الرفض",
    forwarduser:"اعادة ارسال المستخدم",
    forwardreason:"اعادة ارسال الملاحظات",
    businesspartner:"المنشأة",
    jobseeker:"طالب العمل",
    customername:"اسم طالب العمل",
    searchfname:"الإسم الأول لطالب العمل",
    dob:"تاريخ الميلاد",
    smallnin:"رقم الهوية الوطنية",
    approvenin:"الموافقة على ربط طالبي العمل",
    printandactivecon:"طباعة تعميد طلبات الدعم",
    actualmatching:"من ربط وتم الموافقة عليه",
    smallprint:"طباعة",
    convertactive:"تعميد الطباعة",
    printletter:"خطاب تعميد منشأة ببدء برنامج الدعم",
    comprecontract:"الاتفاقيات الشاملة",
    signdate:"تاريخ توقيع الاتفاقية",
    renewdate:"تاريخ تجديد الاتفاقية",
    termdate:"تاريخ إنهاء الاتفاقية",
    activate:"تفعيل",
    addcomcontract:" إضافة الاتفاقيات الشاملة",
    workflowcomplete:"سير العمل المكتمل",
    workflowyearly:"سير العمل حسب السنة",
    permissioncenter:"إدارة الصلاحيات",
    workflowlatest:"أحدث سير العمل",
    welcome:"مرحباً",
    details:"تفاصيل",
    accesscontrol:"تحديد الدخول",
    changepass:"تغيير كلمة المرور",
    userlist:"قائمة المستخدم",
    username:"اسم المستخدم",
    usertype:"النوع",
    userrole:"دور المستخدم",
    internaluser:"داخلي",
    externaluser:"خارجي",
    workflow:"تحويل مسيرة العمل",
    workflowlist:"قائمة مراحل الاجراء",
    processid:"رقم المرحلة",
    proid:"رقم الاجراء",
    processname:"اسم الفئة",
    processdate:"تاريخ العملية",
    enterprocessid:"رقم الاجراء/رقم الفاتورة/رقم طلب الدعم",
    activitydetail:"بيانات المرحلة",
    activitylist:"مراحل العملية",
    activityid: "رقم العملية",
    activityname:"اسم العملية",
    activitydate:"تاريخ التكليف",
    activitytime:"وقت التكليف",
    actiondate:"تاريخ الإجراء",
    smallno:"رقم",
    pro1:"طلب الدعم",
    pro2:"الموافقة على الفاتورة",
    pro3:"تسجيل المنشأة",
    pro4:"تسجيل طالب العمل",
    aspercontract:"نموذج اتفاقية التوظيف/التدريب",
    lastinvoice:"تاريخ الفاتورة الأخيرة",
    terminatenin:"انتهاء التوظيف",
    terminationreason:"سبب انتهاء الخدمة",
    treason1:"السبب الاول",
    treason2:"فصل من العمل",
    treason3:"انقطاع عن العمل",
    treason4:"انهاء العقد لسبب مشروع",
    treason5:"استقاله",
    treason6:"حالة وفاة",
    treason7:"عدم اجتياز فترة التجربة",
    btnterminate:"انهاء خدمته",
    statusonjob:"حالة العقد",
    signount:"تسجيل الخروج",
    createinvoice:"إنشاء فاتورة",
    uploadfile:"تحميل الملف",
    attnininfo:"رواتب الموظفين",
    agreetitle:"التوقيع والاعتماد",
    importexcel:"استيراد إلى إكسل",
    comprint:"الطرف الأول لصندوق والطرف الثاني للمنشأة",
    activepritnereport:"التقرير المرفق مع خطاب التعميد",
    matchednins:"عدد الموظفين المستفيدين",
    commorlicense: "رقم السجل التجاري / رقم الترخيص",
    pmonthsalary:"الراتب الشهري",
    printtameed:"طباعة تعميد",
    previousinv:"الفاتورة السابق",
    invidext:"رقم الفاتورة الخارجية",
    invcreatedate:"تاريخ الفاتورة",
    searchpc:"البحث في طالبي العمل المدعومين",
    btnsearchpc:"البحث طالبي العمل",
    supportduration:"عدد أشهر الدعم",
    searchresult:"نتائج البحث",
    reports:"التقارير",
    bpreport:"الصرف للموظفين المدعومين حسب المنشأة",
    pcreport:"الصرف للموظفين المدعومين حسب الموظف",
    degreetype:"نوع التأهيل",
    lastpaymentdate:"تاريخ آخر صرف على الحساب",
    invpercontract:"عدد الدفعات حسب الاتفاقية",
    nopaidinv:"عدد الفواتير المدفوعة",
    noreminv:"عدد الدفعات المتبقية",
    totlninamount:"جمالي الدعم حسب الاتفاقية",
    invamoutpaid:"اجمالي ماتم صرفه",
    invamoutnotpaid:"مبلغ الدعم الذي لم يتم صرفه",
    moredetail:"عرض التفاصيل",
    smyear:"سنة",
    smmonth:"شهر",
    smsalary:"دعم الراتب",
    pcreportdetail:"المبالغ المطلوب استردادها خلال الفترة المدخلة",
    addattend1: "تم التحضير عدد ",
    addattend2:"من اصل ",
    addattend3:"مستفيد وبالامكان اكمال اصدار الفاتورة ",
    printattinfo:"كشف قيد الحساب",
    gositermdate:"تاريخ الاستقالة\n بالتأمينات الاجتماعية",
    mustchangepassword:"إنشاء كلمة مرور قوية استخدم كلمة مرور ( حروف -ارقام - رموز )",
    approvecontract:" الموافقة طلبات الدعم",
    approvebusiness:"الموافقة تسجيل المنشأة",
    approvepc:"الموافقة تسجيل طالب العمل",
    operation:"عملياتي"
}